module.exports = __webpack_public_path__ + "img/931db7f6e2b1843206b1d8e2cfac0ae8.png";